import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaYoutube,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const YouTubeVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="YouTube Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Grow Your Channel</Subheading>}
        heading={
          <Heading>
            YouTube <span tw="text-primary-500">Video Production</span> in Bur
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in YouTube video production in
            **Bur Dubai**, creating engaging, high-quality videos optimized to
            boost your channel’s views, subscribers, and brand impact.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1609921141835-710b7fa6e438?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video production setup
          "https://images.unsplash.com/photo-1504465039542-a4308c88248f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // YouTube creative filming
          "https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Content creation with Dubai background
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your YouTube Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Professional YouTube Videos in Bur Dubai"
        description="We craft videos that captivate YouTube audiences."
        cards={[
          {
            icon: <FaYoutube color="#ff5464" size={40} />,
            title: "Channel Growth",
            description: "Videos designed to increase views and subscribers.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Stunning Quality",
            description: "Crisp visuals and sound for a professional look.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Delivery",
            description: "Fast production to keep your channel active.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "YouTube Optimized",
            description: "Tailored for thumbnails, SEO, and engagement.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Creators",
            description: "Bur Dubai’s go-to for YouTube content.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Custom Content",
            description: "Vlogs, tutorials, or promos to suit your niche.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our YouTube Video Production Process"
        description={
          <Description>
            We create impactful YouTube videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Align with your channel’s goals and audience.
              </li>
              <li>Scripting: Plan engaging content with strong hooks.</li>
              <li>Filming: Capture visuals with high-end equipment.</li>
              <li>Editing: Enhance with intros, captions, and effects.</li>
              <li>Delivery: Provide ready-to-upload videos with SEO tips.</li>
              <li>Support: Offer guidance for posting and analytics.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1551847677-dc82d764e1eb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Content planning
          "https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video editing
          "https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Camera equipment filming
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="YouTube Video Wins in Bur Dubai"
        description="Our videos have driven channel success."
        cards={[
          {
            icon: <FaYoutube color="#ff5464" size={40} />,
            title: "Subscriber Surge",
            description: "Boosted channels with engaging content.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Creator Praise",
            description: "94% satisfaction from Bur Dubai YouTubers.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "View Growth",
            description: "Increased watch time and engagement.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Shine on YouTube?</Subheading>}
        heading="YouTube Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert YouTube video production in
            Bur Dubai. Get professional, engaging videos to grow your
            channel—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1626368305730-9461fba72d6d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Professional filming
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Content creation
          "https://images.unsplash.com/photo-1611162616475-46b635cb6868?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video production setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
